import { memo } from 'react';

export type StepHeaderProps = {
  title: string;
  description?: string;
};

export const StepHeader = memo(({ title, description }: StepHeaderProps) => {
  return (
    <div className="flex flex-col gap-1">
      <h2 id="onboarding-dialog-title" className="font-medium ads:text-primary text-24 text-gray-12">
        {title}
      </h2>
      {!!description && <p className="ads:text-primary text-14 text-gray-12">{description}</p>}
    </div>
  );
});

StepHeader.displayName = 'StepHeader';
